/**
 * @module services/sProgress/component
 */

import Vue from "vue";
import Component from "vue-class-component";
import { vueTopprogress } from "vue-top-progress";
import singletons from "@/services/singletons";

@Component({
  components: {
    vueTopprogress
  }
})
export default class ProgressBarComponent extends Vue {
  private blocked: boolean = false;
  private startCount: number = 0;

  $refs: {
    progress: any;
  };

  constructor() {
    super();
    this.$refs = {} as any;
  }

  private mounted() {
    singletons.progressBar = this;
  }

  /**
   * Method to start and stop progress-bar automatically.
   * Bar Done when resolved.
   * Failed when rejected.
   * @author Davinder Singh
   * @param {Promise<any>} promise Promise to hook callbacks to.
   * @param {(boolean | undefined)} isBlocking If true, the UI will be blocked to prevent user from making any input either by keyboard or mouse.
   */
  startAuto(promise: Promise<any>, isBlocking?: boolean | undefined) {
    let timeoutId = setTimeout(() => {
      this.progressStarter(promise);
    }, 200);

    if (isBlocking) {
      this.blocked = true;
      document.onkeydown = () => false;
    }

    promise.catch(() => {}).finally(() => {
      //cancelling starter if action completed before 200 ms
      clearTimeout(timeoutId);

      this.blocked = false;
      document.onkeydown = () => true;
    });
  }

  /**
   * Method that starts progress bar and stops automatically.
   * For internal use by startAuto
   * @author Davinder Singh
   * @param {Promise<any>} promise
   */
  private progressStarter(promise: Promise<any>) {
    this.startCount++;
    if ((this.$refs.progress.status || 0) < 20) {
      this.$refs.progress.start();
      this.$nextTick(() => {
        this.$refs.progress.increase(20);
      });
    }

    promise
      .then(() => {
        this.startCount--;
        if (!this.startCount) {
          this.$refs.progress.done();
        }
      })
      .catch(() => {
        this.startCount = 0;
        this.$refs.progress.fail();
      });
  }

  /**
   * Method to start progress bar manually.
   *
   * @author Davinder Singh
   */
  start() {
    this.$refs.progress.start();
  }
  /**
   * Method to pause progress bar manually.
   * @author Davinder Singh
   */
  pause() {
    this.$refs.progress.pause();
  }
}
